const LOGO_URL = "/logo.svg";

export function PowerBESSLogo({ size = 24, className = "" }) {
  return (
    <img
      src={LOGO_URL}
      alt="PowerBESS"
      width={size}
      height={size}
      className={className}
      draggable={false}
    />
  );
}

export function PowerBESSBrand({ size = 20, textClass = "", logoClass = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 ${textClass}`}>
      <PowerBESSLogo size={size} className={logoClass} />
      <span className="font-clash font-semibold">Power<span className="text-primary">BESS</span>.ai</span>
    </span>
  );
}
